export default {
  BUTTON_PRIMARY_CLASS: 'cm_button button-primary',
  BUTTON_SECONDARY_CLASS: 'cm_button button-secondary',

  MAIN_CONTENT_CLASS: 'productgrid--wrapper',

  SEARCH_BOX_CLASS: 'live-search-form form-fields-inline',
  SEARCH_BOX_INPUT_CLASS: 'form-field-input live-search-form-field',
  SEARCH_BOX_BUTTON_CLASS: 'live-search-button',
  SEARCH_BOX_FORM_CLASS: 'form-field no-label',
  SEARCH_BOX_PLACEHOLDER:
    '{window.Convermax?.config?.search_placeholder || "Search by pattern name, number or style…"}',

  FILTER_SEARCH_BOX_BUTTON_CLASS: 'live-search-button',
  FILTER_SEARCH_BOX_FORM_CLASS: 'live-search-form form-fields-inline form-field no-label',
  FILTER_SEARCH_BOX_INPUT_CLASS: 'form-field-input live-search-form-field',
  FILTER_SEARCH_BOX_PLACEHOLDER: 'Search within Samples',

  MAX_PRICE: 'Max',
  MIN_PRICE: 'Min',

  SORT_BY: 'Sort by',
  START_OVER: 'Clear',

  PRODUCT_REPEATER_CLASS: 'productgrid--items products-per-row-4',
};
